document.addEventListener("DOMContentLoaded", function () {
    // Inicializar WaveSurfer para el audio principal
    const wavesurfer = WaveSurfer.create({
        container: "#waveform",
        waveColor: "white",
        progressColor: "red",
        cursorColor: "transparent",
        barWidth: 2,
        responsive: true,
        height: 80
    });

    // Cargar el archivo principal
    wavesurfer.load("https://cdn.shopify.com/s/files/1/0914/1387/2946/files/MASHU.mp3?v=1739393793");

    // Botón de Play/Pause para el audio principal
    const playPauseBtn = document.getElementById("playPauseBtn");
    playPauseBtn.addEventListener("click", () => {
        if (wavesurfer.isPlaying()) {
            wavesurfer.pause();
            playPauseBtn.textContent = "▶";
        } else {
            wavesurfer.play();
            playPauseBtn.textContent = "⏸";
        }
    });

    // Lista de todas las muestras de audio
    const samples = [
        { id: "waveform1", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Assassin_-_182_BPM_C_Min.wav?v=1739400714" }, { id: "waveform2", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Drift_-_170_BPM_E_Min.wav?v=1739400744" },
        { id: "waveform3", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Retail_-_177_BPM_C_Min.wav?v=1739400815" }, { id: "waveform4", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Tripp_-_174_BPM_G_Min.wav?v=1739400854" },
        { id: "waveform5", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DRUM_KIT_MUESTRA.wav?v=1739398985" }, { id: "waveform6", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_808_Crime_C.wav?v=1739401079" },
        { id: "waveform7", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Snare_TalkShow.wav?v=1739401211" }, { id: "waveform8", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/DRUM_KIT_MUESTRA_2.wav?v=1739401746" },
        { id: "waveform9", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/flute.wav?v=1738764014" }, { id: "waveform10", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Boulevard_160_BPM_F_Min.wav?v=1739401414" },
        { id: "waveform11", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Park_Avenue_174_BPM_G_Min.wav?v=1739401522" }, { id: "waveform12", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_PHRASE_Pedestrian_Zone_-_182_BPM_B_Min.wav?v=1739401619" },
        { id: "waveform13", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/KEYS_-_Getaway.wav?v=1739407685" }, { id: "waveform14", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BELL_-_Forgery.wav?v=1739407685" },
        { id: "waveform15", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BASS_-_Multiplayer.wav?v=1739407685" }, { id: "waveform16", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/BELL_-_Falsification.wav?v=1739407685" },
        { id: "waveform17", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Legal_MIDI_-_D_Min.wav?v=1739400535" }, { id: "waveform18", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_City_MIDI_-_B_Min.wav?v=1739400535" },
        { id: "waveform19", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Innovation_MIDI_-_E_Min.wav?v=1739400535" }, { id: "waveform20", file: "https://cdn.shopify.com/s/files/1/0914/1387/2946/files/Sonnity_-_Skyline_MIDI_-_D_Min.wav?v=1739400535" },
        { id: "waveform21", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/DETROIT_PA_LAS_BABYS.mp3?v=1776905498" }, { id: "waveform22", file: "https://cdn.shopify.com/s/files/1/0960/7849/6051/files/DETROIT_MALEANTEO.mp3?v=1776905512" }
    ];

    let wavesurfers = {};

    // Inicializar todas las muestras de audio
    samples.forEach(sample => { 
        wavesurfers[sample.id] = WaveSurfer.create({
            container: `#${sample.id}`,
            waveColor: "white",
            progressColor: "red",
            cursorColor: "transparent",
            barWidth: 2,
            responsive: true,
            height: 40
        });
      
        wavesurfers[sample.id].load(sample.file);
    });

    // Botones de reproducción para cada muestra de audio
    document.querySelectorAll(".play-btn").forEach(btn => {
        btn.addEventListener("click", function () {
            const waveformId = this.nextElementSibling.id;
            if (wavesurfers[waveformId].isPlaying()) {
                wavesurfers[waveformId].pause();
                this.textContent = "▶";
            } else {
                // Pausar todas las demás muestras antes de reproducir una nueva
                Object.keys(wavesurfers).forEach(id => wavesurfers[id].pause());
                document.querySelectorAll(".play-btn").forEach(b => (b.textContent = "▶"));

                wavesurfers[waveformId].play();
                this.textContent = "⏸";
            }
        });
    });

    // Función para preguntas frecuentes (FAQ)
    document.querySelectorAll(".faq-question").forEach(btn => {
        btn.addEventListener("click", function () {
            const answer = this.nextElementSibling;
            const toggleSign = this.querySelector(".faq-toggle");

            if (answer.style.maxHeight) {
                answer.style.maxHeight = null;
                answer.style.opacity = "0";
                toggleSign.textContent = "+";
            } else {
                document.querySelectorAll(".faq-answer").forEach(ans => {
                    ans.style.maxHeight = null;
                    ans.style.opacity = "0";
                });
                document.querySelectorAll(".faq-toggle").forEach(sign => (sign.textContent = "+"));

                answer.style.maxHeight = answer.scrollHeight + "px";
                answer.style.opacity = "1";
                toggleSign.textContent = "-";
            }
        });
    });
});
